import { useState, useRef } from 'react'
import { Link, useParams } from 'react-router-dom';

import { useSelector } from 'react-redux';

import Sidebar from '../../../components/sidebar/Sidebar';
import HeaderBtn from '../../../components/headerBtn/headerBtn';

import ProjectVacancy from '../../../pages/projects/projectVacancy/projectVacancy';

import SectionContent from '../../../components/sectionContent/sectionContent';

import '../../../scss/App.scss';

import { IProjestListOptions } from "../../../types/projectsInterface";

const ProjectVacancySection = () => {
	const { id } = useParams<{ id: string }>();

	const { data } = useSelector((state: any) => state.projects.projects);
	const { claims } = useSelector((state: any) => state.user.user.data);

	const [overflowedBtnsCount] = useState<number>(0);

	const buttonsContainerRef = useRef<HTMLDivElement>(null);

	const availableButtons = [
		{
			component: (
				<HeaderBtn
					content='Настройки'
					purpose='vacancyListSettings'
					modalTitle='Настройки'
				/>
			)
		},
		(claims.includes('admin') || claims.includes('recruiting:vacancy:edit')) &&{
			component: (
				<HeaderBtn
					content='Создать вакансию'
					purpose='createVacancyVacant'
					modalTitle='Создать вакансию'
				/>
			)
		},
		(claims.includes('admin') || claims.includes('recruiting:vacancy:export')) && {
			component: (
				<HeaderBtn
					content='Выгрузить данные'
					purpose='UnloadData'
					modalTitle='Выгрузить данные'
					hasIcon='excel'
				/>
			)
		}
	]

	const filteredAvailableButtons = availableButtons.filter((btn: { component: JSX.Element }) => btn);

	const displayedAvailableBtns = filteredAvailableButtons
		?.slice(-(overflowedBtnsCount as number))
		?.map((elem: { component: JSX.Element }, index: number) => {
			return elem && <div key={index}>{elem?.component}</div>;
		});

	const displayedHeadBtns = filteredAvailableButtons
		?.slice(0, filteredAvailableButtons.length - overflowedBtnsCount)
		?.map((elem: { component: JSX.Element }, index: number) => {
			return elem && <div key={index}>{elem?.component}</div>;
		});

	const currentPageTitle =
		data &&
		data.find((el: IProjestListOptions) => el?.project?.id === parseFloat(id as string))?.project?.name;

			return (
		<div className='App'>
			<Sidebar />
			<SectionContent
				title={currentPageTitle && currentPageTitle}
				availableButtons={displayedAvailableBtns}
				buttonsContainerRef={buttonsContainerRef}
				headBlockChildren={displayedHeadBtns}
				pageName='projectInfo'
				section='Проекты'
			>
				<div className='content__main'>
					<div className='btns'>
						<Link to={`/projects/${id}/info`} className='tab'>
							<div className='buttons__btn'>Информация</div>
						</Link>
						{(claims.includes('admin') ||
							claims.includes('projects:routes:list')) && (
								<Link
									to={`/projects/${id}/routes`}
									className='tab'
								>
									<div className='buttons__btn'>Маршруты</div>
								</Link>
							)}
						<Link
							to={`/projects/${id}/vacancy`}
							className='tab'
						>
							<div className='buttons__btn --active'>Вакансии</div>
						</Link>
					</div>
					<ProjectVacancy />
				</div>
			</SectionContent>
		</div>
	);
};

export default ProjectVacancySection;
